<!-- 项目文件 -->
<template>
    <div>
        <Header :Logo="logo" ref="mychild" :Waytype="waytype" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w1200 mauto pt30">
            <div class="textc mt20 mb20">
                <p class="fs36 c333 disinblock posre">
                    <span class="border-bottom1">
                        业务模式
                    </span>
                </p>
            </div>
            <div class="lh26">
                <p class="c000 fs16 pb20 fbold">
                    商家的快速经营拓客助手
                </p>
                <p  class="c333 fs16 pb20 textindent2">
                    为驾校提供专业版的招生营销小程序,海量应季热点海报,拼团、砍价、优惠券营销活动模板、二级分销、客户AI智能追踪,招生排行与非微信好友无障碍在线沟通
                    满足驾校的招生细节要;小程序除驾校专业版以外,也有适用于企业销售的商业版,打破合作伙伴市场拓展的行业壁垒。
                </p>
                <p class="pb50 pt30">
                    <img class="imgauto" src="../../public/img/img299.png" alt="">
                </p>
                <div class="fs16 c333 pb50 lh26 ">
                    <P class="fs16 c000 pb20 fbold">盈利模式</P>
                    <P>1、合作伙伴通过平台招商引入流量合作/经营，80%收益归合作伙伴所有。</P>
                    <P>2、平台引入推广的产品合作，合作伙伴可获取其推广区域成交价格20%的推广费用。</P>
                    <P>3、合作伙伴可获得长期流量收益稳定。</P>
                </div>
                
                <div class=" pb20 fs16 c333 lh26">
                    <P class="fs16 c000 pb20  fbold">准入条件</P>
                
                    <P>1)必须依法注册，可以独立承担民事责任的企业单位/可以独立承担民事责任的个人。</P>
                    <P>2)良好的客户覆盖服务能力：市场开拓和市场驾驭能力强，有驾培行业客户资源优势和较强的客户服务能力者优先考虑。</P>
                    <P>3)熟悉代理招募地区和驾培驾考行业发展状况，熟悉驾培驾考行业广告业务特点和发展趋势，具有丰富的互联网经营经验者优先。</P>
                    <P>4)良好渠道开拓运营能力：认同公司的渠道管理理念和经营模式，具有真诚、长期合作意向。</P>
                    <P>5)良好的业绩营收能力：能准确预估市场份额，并使e学e驾市场影响力与业务量到达本区域行业前列，同时具备较强的营销活动策划、组织、执行能力，能接受公司安排的业绩任务。</P>
                    <P>6)有竞争力（代理）意识：认同e学e驾的产品理念，对驾培市场有憧憬，并给出有竞争力的业务量。</P>
                </div>
                <div class="pl40 pr40 pb20">
                    <div class="textc mt20 mb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="">
                                加盟入驻
                            </span>
                        </p>
                    </div>
                    <div class="textc">
                        <div class="pb30">
                            <p class="disinblock vermid  posre w100">
                                <img class="h62 w62" src="../../public/img/img294.png" alt="">
                                <span class="disblock fs20 c333 bottom-25 posab w100p ">提交加盟</span>
                            </p>
                
                            <p class="disinblock vermid  ">
                                <img class="h2 w180 vermid" src="../../public/img/img298.png" alt="">
                            </p>
                
                            <p class="disinblock vermid  posre w100">
                                <img class="h62 w62" src="../../public/img/img295.png" alt="">
                                <span class="disblock fs20 c333 bottom-25 posab w100p ">登陆入驻</span>
                            </p>
                
                            <p class="disinblock vermid ">
                                <img class="h2 w180 vermid" src="../../public/img/img298.png" alt="">
                            </p>
                
                            <p class="disinblock vermid  posre w100">
                                <img class="h62 w62" src="../../public/img/img296.png" alt="">
                                <span class="disblock fs20 c333 bottom-25 posab w100p ">平台使用</span>
                            </p>
                
                            <p class="disinblock vermid ">
                                <img class="h2 w180 vermid" src="../../public/img/img298.png" alt="">
                            </p>
                
                            <p class="disinblock vermid  posre w100">
                                <img class="h62 w62" src="../../public/img/img297.png" alt="">
                                <span class="disblock fs20 c333 bottom-25 posab w100p ">入驻推广</span>
                            </p>
                        </div>
                        <div class="pt60  textc pb20">
                            <span @click="openChild()"
                                class="cfff cursor bg1f8 bradius5 fs18 disinblock fbold h50 lh50 w240">合作申请</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    export default {
        data() {
            return {
                bgImg: require('../../public/img/img87.png'),
                titleList: 3,
                link: 1,
                logo: 'coop',
                color: 2,
                waytype: 1
            };
        },
        components: {
            Header,
            Footer,

        },
        methods: {
            openChild() {
                this.$refs.mychild.foo();
            }
        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>

</style>